import { useCallback, useEffect, useState } from "react";
import { client } from "../lib/axiosClient";
import Cookies from 'universal-cookie';

const cookies = new Cookies(null, { path: '/' });

interface _Props {
    idMarketer: string;
}
export const useInvocesMarketer = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    const fetchData = useCallback(async ({idMarketer}: _Props) => {
        setLoading(true);
        try {
            const response = await client.get(`/invoices`, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': cookies.get('token') || ""
                },
                params: {
                    idMarketer
                }
            });
            
            if (response.status !== 200) {
                throw new Error('Failed to fetch data');
            }
            setData(response?.data)
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }, []);
    
    const refetch = useCallback(({idMarketer}: _Props) => {
        fetchData({idMarketer});
    }, [fetchData]);

      
    return { data, loading, error, fetchData, refetch };
}